import React, { useEffect, useState } from "react";
import { Modal, Toast } from "react-bootstrap";
import middleware from "../../../Api/Middleware.js";
import ToastError from "../../../Toasts/ToastError.js";
import ToastSuccess from "../../../Toasts/ToastSuccess.js";
import { ButtonBlue, ButtonDarkBlue } from "../../../HouseStyle/Components/Buttons.js";
import { BorderedNumberInput, BorderedTextInput } from "../../../HouseStyle/Components/Inputs.js";
import "../../../Modals/ModalStyle.css";
import LoadingIcon from "../../../HouseStyle/Components/LoadingIcon.js";

function GiftcardSettingsModal({ show, setShow,setExpiDate}) {
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [settings, setSettings] = useState({});

    useEffect(() => {
        if (show) {
            fetchSettings();
        }
    }, [show]);

    const fetchSettings = async () => {
        try {
            const settingsApiResponse = await middleware.get('settings/giftcards');
            setSettings(settingsApiResponse.data.data[0]);
            setLoading(false);
        } catch (error) {
            ToastError("Er is iets fout gegaan bij het ophalen van de instellingen. Probeer het later opnieuw");
        }
    };

    const updateSettings = async () => {
        try {
            const validityDays = parseInt(settings.validity_days) || 730;
            
            if(validityDays < 730) {
                ToastError("De cadeaukaart moet minstens 2 jaar geldig zijn!");
                return;
            }
            
            const updateSettingsApiResponse = await middleware.put('settings/giftcards', {
                giftcard_id: settings.giftcard_id,
                validity_days: validityDays
            });
            if (updateSettingsApiResponse.data.status == "success") {
                setExpiDate(validityDays);
                ToastSuccess("Instellingen bijgewerkt", 'settings_updated');
                handleClose()
            }
        } catch (error) {
            console.error(error)
            ToastError("Er is iets fout gegaan bij het bewerken van de interval. Probeer het later opnieuw");
        }
    };

    const formatDaysToReadable = (days) => {
        if (!days || days === 0) return "Geen vervaldatum";

        const years = Math.floor(days / 365);
        const remainingDaysAfterYears = days % 365;
        const months = Math.floor(remainingDaysAfterYears / 30);
        const remainingDays = remainingDaysAfterYears % 30;

        const parts = [];
        
        if (years > 0) {
            parts.push(`${years} ${years === 1 ? 'jaar' : 'jaar'}`);
        }
        if (months > 0) {
            parts.push(`${months} ${months === 1 ? 'maand' : 'maanden'}`);
        }
        if (remainingDays > 0) {
            parts.push(`${remainingDays} ${remainingDays === 1 ? 'dag' : 'dagen'}`);
        }

        return parts.join(', ');
    };

    const handleClose = () => {
        setShow(false);
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            className="modalEditLabel"
            centered
            size="m"
        >
            <Modal.Header className="modalTop justify-content-between" closeButton>
                <Modal.Title>Cadeaukaart instellingen</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modalCenter">
                {!loading ?
                    <div className="d-flex flex-column gap-2">
                        <BorderedNumberInput
                            label="Invaliditeitsinterval (dagen)"
                            minAmount={730}
                            inputValue={settings.validity_days?.toString() ?? '730'}
                            setInputValue={(newValue) => {
                                const parsed = parseFloat(newValue);
                                setSettings(prev => ({ 
                                    ...prev, 
                                    'validity_days': isNaN(parsed) ? 730 : parsed 
                                }));
                            }}
                            placeholder='dagen'
                            size='m'
                        />
                        <div className="BeneathFlatText ms5">
                            Cadeaukaarten zijn geldig voor {formatDaysToReadable(settings.validity_days)} na een nieuwe opwaardering
                        </div>
                    </div>
                :
                    <div className="d-flex w-100 justify-content-center">
                        <LoadingIcon/>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer className="modalBottom">
                <div className="d-flex flex-row gap-4">
                    <ButtonDarkBlue
                        text="Annuleren"
                        onClickFunction={handleClose}
                    />
                    <ButtonBlue
                        text={updating ? "Bezig..." : "Bijwerken"}
                        disabled={updating || loading}
                        onClickFunction={updateSettings}
                        size=""
                    />
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default GiftcardSettingsModal;